let AnalysisModel = function (id,position) {
    var canvas = document.getElementById(id);
    if (canvas == null) return false;
    var ctx = canvas.getContext('2d');
    // 先画边框
    ctx.strokeStyle = '#e0e0e0';
    ctx.lineWidth = 1;
    ctx.strokeRect(0, 0, 540, 860);

    ctx.beginPath();
    // 命位上下线
    ctx.moveTo(0, 70);
    ctx.lineTo(540, 70);
    ctx.moveTo(0, 610);
    ctx.lineTo(540, 610);
    //本位下线
    ctx.moveTo(0, 730);
    ctx.lineTo(540, 730);
    // 本位中线
    ctx.moveTo(154,670);
    ctx.lineTo(540,670);

    // 分块线
    for(let i = 0; i<9;i++) {
        ctx.moveTo(72, 70+i*60);
        ctx.lineTo(540, 70+i*60);     
    }

    // 竖线 从左向右
    ctx.moveTo(72, 70);
    ctx.lineTo(72, 610);
    
    for (let i = 2; i< 9; i++) {

        ctx.moveTo(78*i, 70);
        ctx.lineTo(78*i, 860); 
        
    }
    
    ctx.closePath();
    ctx.stroke();

    // 填写内容

    ctx.font = "30px Heiti SC, Arial";
    ctx.fillStyle = '#a02f3a';
    ctx.fillText("火", 178, 652);
    ctx.fillStyle = '#59a4d1';
    ctx.fillText("水", 256, 652);
    ctx.fillStyle = '#d7b836';
    ctx.fillText("金", 333, 652);
    ctx.fillStyle = '#c69465';
    ctx.fillText("土", 411, 652);
    ctx.fillStyle = '#759165';
    ctx.fillText("木", 489, 652);
    
    ctx.fillStyle = '#999';
    ctx.font = "18px Heiti SC, Arial";
    for (let i = 1; i < 10; i++) {
        ctx.fillText("第", 90, 49 + i * 60);
        ctx.fillText("位", 120, 49 + i * 60);
    }
    ctx.font = "24px Heiti SC, Arial";
    for (let i = 1; i < 10; i++) {
        ctx.fillText(10 - i, 107, 50 + i * 60);
    }

    ctx.fillStyle = '#333';
    ctx.font = "24px Heiti SC, Arial";
    ctx.fillText("问题", 169, 770);
    ctx.fillText("机会", 169, 803);
    ctx.fillText("轮", 179, 836);
    ctx.fillText("三门", 247, 782);
    ctx.fillText("系统", 247, 822);
    ctx.fillText("根", 337, 804);
    ctx.fillText("地盘", 403, 804);
    ctx.fillText("微弦", 481, 804);

    ctx.fillStyle = '#999';    
    ctx.fillText("A", 185, 712);
    ctx.fillText("B", 263, 712);
    ctx.fillText("C", 341, 712);
    ctx.fillText("D", 419, 712);
    ctx.fillText("E", 497, 712);   

    ctx.fillStyle = '#999';    
    ctx.font = "22px Heiti SC, Arial";
    ctx.fillText("注：实底色块为个人思维排序", 120, 898);

    ctx.fillStyle = '#333';    
    ctx.font = "28px Heiti SC, Arial";
    ctx.fillText("盘山五行思维分析模型", 130, 46);
    ctx.fillText("个", 22, 305);
    ctx.fillText("人", 22, 355);
    ctx.fillText("位", 22, 405);
    ctx.fillText("本位", 51, 684);
    ctx.fillText("本位工具", 21, 804);

    // 每个块之间的width=70 height=60 边框1

    // console.log(position)
    // var position = [1, 1, 1, 1, 1];
    // 先判断第一个位置 起始点[72,60]
    
    switch (Number(position[0])) {
        case 1:
        case 2:
        ctx.fillStyle = "#59a4d1";
        break;
        case 3:
        case 4:
        ctx.fillStyle = "#a02f3a";
        break;
        case 5:
        ctx.fillStyle = "#c69465";
        break;
        case 6:
        case 7:
        ctx.fillStyle = '#d7b836';
        break;
        default:
        ctx.fillStyle = "#759165";
        break;
    }
    ctx.fillRect(155, 70 + 60 * (9 - Number(position[0])), 78, 60);
    
    // 第二个位置
    switch (Number(position[1])) {
        case 1:
        case 2:
        ctx.fillStyle = "#d7b836";
        break;
        case 3:
        case 4:
        ctx.fillStyle = "#59a4d1";
        break;
        case 5:
        ctx.fillStyle = "#c69465";
        break;
        case 6:
        case 7:
        ctx.fillStyle = "#759165";
        break;
        default:
        ctx.fillStyle = "#a02f3a";
        break;
    }
    ctx.fillRect(233, 70 + 60 * (9 - Number(position[1])), 78, 60);

    // 第三个位置
    switch (Number(position[2])) {
      case 1:
      case 2:
        ctx.fillStyle = "#759165";
        break;
      case 3:
      case 4:
        ctx.fillStyle = "#d7b836";
        break;
      case 5:
      case 6:
        ctx.fillStyle = "#59a4d1";
        break;
      case 7:
        ctx.fillStyle = "#c69465";
        break;
      default:
        ctx.fillStyle = "#a02f3a";
        break;
    }
    ctx.fillRect(312, 70 + 60 * (9 - Number(position[2])), 78, 60);

    // 第四个位置
    switch (Number(position[3])) {
      case 1:
      ctx.fillStyle = "#59a4d1";
      break;
      case 2:
      case 3:
      ctx.fillStyle = "#c69465";
      break;
      case 4:
      case 5:
      ctx.fillStyle = "#d7b836";
      break;
      case 6:
      case 7:
        ctx.fillStyle = "#759165";
        break;
      default:
        ctx.fillStyle = "#a02f3a";
        break;
    }
    ctx.fillRect(390, 70 + 60 * (9 - Number(position[3])), 78, 60);

        // ctx.fillStyle = '#a02f3a';
    // ctx.fillText("火", 165, 714);
    // ctx.fillStyle = '#59a4d1';
    // ctx.fillText("水", 235, 714);
    // ctx.fillStyle = '#d7b836';
    // ctx.fillText("金", 306, 714);
    // ctx.fillStyle = '#c69465';
    // ctx.fillText("土", 378, 714);
    // ctx.fillStyle = '#759165';
    // ctx.fillText("木", 449, 714);
    // 第五个位置
    switch (Number(position[4])) {
      case 1:
      case 2:
        ctx.fillStyle = "#a02f3a";
        break;
      case 3:
      case 4:
        ctx.fillStyle = "#759165";
        break;
      case 5:
      case 6:
        ctx.fillStyle = "#59a4d1";
        break;
      case 7:
        ctx.fillStyle = "#c69465";
        break;
      default:
        ctx.fillStyle = "#d7b836";
        break;
    }
    ctx.fillRect(467, 70 + 60 * (9 - Number(position[4])), 78, 60);
    ctx.fill();

    

    ctx.font = "30px Heiti SC, Arial";
    var arr11 = ['木', '木', '金', '金', '土', '火', '火', '水', '水'];
    for(let i = 0;i<arr11.length;i++) {
        i == (9-Number(position[0])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
        ctx.fillText(arr11[i], 178, 110+ i*60);        
    }  


    var arr21 = ['火', '火', '木', '木', '土', '水', '水' ,'金', '金'];
    for (let i = 0; i < arr21.length; i++) {
        i == (9 - Number(position[1])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr21[i], 256, 110 + i * 60);
    }

    var arr31 = ['火', '火', '土', '水', '水', '金', '金' ,'木', '木'];
    for (let i = 0; i < arr31.length; i++) {
        i == (9 - Number(position[2])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';        
      ctx.fillText(arr31[i], 334, 110 + i * 60);
    }

    var arr41 = ['火', '火', '木', '木', '金', '金', '土', '土','水'];
    for (let i = 0; i < arr41.length; i++) {
        i == (9 - Number(position[3])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr41[i], 412, 110 + i * 60);
    }

    var arr51 = ['金', '金', '土', '水', '水', '木', '木' ,'火', '火'];
    for (let i = 0; i < arr51.length; i++) {
        i == (9 - Number(position[4])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr51[i], 490, 110 + i * 60);
    }

    ctx.font = "14px Heiti SC, Arial";  
    var arr12 = [3,8,4,9,5,2,7,1,6];
    for (let i = 0; i < arr12.length; i++) {
        i == (9 - Number(position[0])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
        ctx.fillText(arr12[i], 210, 90 + i * 60);
    } 
    
    var arr22 = [7, 2, 3, 8, 5, 1, 6, 4, 9];
    for (let i = 0; i < arr22.length; i++) {
        i == (9 - Number(position[1])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr22[i], 288, 90 + i * 60);
    }

    var arr32 = [7, 2, 5, 1, 6, 4, 9, 3, 8];
    for (let i = 0; i < arr32.length; i++) {
        i == (9 - Number(position[2])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr32[i], 366, 90 + i * 60);
    }

    var arr42 = [7, 2, 3, 8, 4, 9, 5, 10, 6];
    for (let i = 0; i < arr42.length; i++) {
        i == (9 - Number(position[3])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';        
      ctx.fillText(arr42[i], 444, 90 + i * 60);
    }

    var arr42 = [9, 4, 5, 1, 6, 3, 8, 2, 7];
    for (let i = 0; i < arr42.length; i++) {
        i == (9 - Number(position[4])) ? ctx.fillStyle = '#fff' : ctx.fillStyle = '#333';
      ctx.fillText(arr42[i], 522, 90 + i * 60);
    }













};
export default AnalysisModel;


// WEBPACK FOOTER //
// ./src/js/fiveElesAnalysisModel.js